  
import { CookieService } from 'ngx-cookie-service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, BehaviorSubject, from } from 'rxjs';
import { CacheService } from '../../../shared/services/cache.service';
import { Router } from '@angular/router';
export namespace SalesEntityConstants {
	export const DEFAULT_ID = 0;
}

@Injectable()
export class SeatService {
	controller = 'api/salesentity/';  

	constructor(
		private http: HttpClient,
		private cookieSvc: CookieService,
		private cacheService: CacheService,
		private router: Router
	) { 
	}
   
	public getSalesEntity(entityID?: number): Observable<any> {
		const url = this.controller + 'GetSalesEntityById/' + entityID; 
		return this.http.get<any>(url);
	} 
} // class
